const SvgSecurity1 = (props) => (
  <>
    <defs />
    <path
      d="M191.64 64h160M191.64 128h160M191.59 192h160M346.87 256h-156M315.82 320h-124M32 0v215.87C32 308.34 104 384 192 384s160-75.66 160-168.13V0H32ZM192 0v384"
      stroke="#042068"
      strokeWidth="3px"
      fill="none"
      strokeMiterlimit={10}
    />
    <circle cx={192} cy={64} r={8} fill="#1e62f5" strokeWidth={0} />
    <circle cx={192} cy={64} r={24} stroke="#021d6c" fill="none" strokeMiterlimit={10} />
    <circle cx={192} cy={192} r={8} fill="#1e62f5" strokeWidth={0} />
    <circle cx={192} cy={192} r={24} stroke="#021d6c" fill="none" strokeMiterlimit={10} />
    <circle cx={192} cy={320} r={8} fill="#1e62f5" strokeWidth={0} />
    <circle cx={192} cy={320} r={24} stroke="#021d6c" fill="none" strokeMiterlimit={10} />
  </>
);

export default SvgSecurity1;
